export default "__VITE_ASSET__78fdb166__"